import axios from 'axios';
import { toast } from 'react-toastify';

const API_BASE_URL = process.env.REACT_APP_API_URL;

// Debug: Ver variables de entorno de PHP API
console.log('🔍 Variables de entorno PHP API:', {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  NODE_ENV: process.env.NODE_ENV
});

// Validar que la URL de la API esté configurada
if (!API_BASE_URL) {
  console.error('❌ REACT_APP_API_URL no está configurada en el archivo .env');
  console.error('⚠️  El servidor de React necesita reiniciarse para cargar las variables de entorno del .env');
  console.error('💡 Pasos a seguir:');
  console.error('   1. Detén el servidor (Ctrl+C)');
  console.error('   2. Reinicia con: npm start');
  console.error('   3. Asegúrate de que el archivo .env esté en la raíz de sgc-frontend/');
  console.warn('🔄 Usando URL de fallback temporalmente:', 'http://127.0.0.1:8000/api');
} else {
  console.log('✅ API_BASE_URL configurada correctamente:', API_BASE_URL);
}

// Cliente base configurado
const apiClient = axios.create({
  baseURL: API_BASE_URL || 'http://127.0.0.1:8000/api', // Fallback por si no está configurado
  timeout: 300000, // Aumentado a 5 minutos
});

console.log('🌐 Axios baseURL configurado como:', apiClient.defaults.baseURL);

// Interceptor para agregar token automáticamente
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.metadata = { startTime: performance.now() };
    return config;
  },
  (error) => {
    console.error('❌ INTERCEPTOR REQUEST ERROR:', error);
    return Promise.reject(error);
  }
);

// Interceptor para manejo de errores
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const duration = error.config?.metadata ? performance.now() - error.config.metadata.startTime : 0;
    console.error(`❌ INTERCEPTOR ERROR: ${error.config?.method?.toUpperCase()} ${error.config?.url} - Duración: ${duration.toFixed(2)}ms - Error:`, error.message);
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      toast.error('Sesión expirada. Por favor, inicie sesión nuevamente.');
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    }

    if (error.response?.status >= 500) {
      toast.error('Error del servidor. Intente nuevamente.');
    }

    return Promise.reject(error);
  }
);

export default apiClient;
export { apiClient as baseApi };
